"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySign = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var currensy_sign_scss_1 = tslib_1.__importDefault(require("./currensy-sign.scss"));
var currencies_1 = require("@wix/wix-vod-constants/dist/common/currencies");
var bm_additional_currencies_1 = require("@wix/wix-vod-constants/dist/common/bm-additional-currencies");
var CurrencySign = /** @class */ (function (_super) {
    tslib_1.__extends(CurrencySign, _super);
    function CurrencySign() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CurrencySign.prototype.render = function () {
        var currency = this.props.currency;
        return (react_1.default.createElement("div", { className: currensy_sign_scss_1.default.currencySign }, currencies_1.CURRENCIES[currency].symbol));
    };
    CurrencySign.propTypes = {
        currency: prop_types_1.default.oneOf(Object.values(bm_additional_currencies_1.Currencies)),
    };
    CurrencySign.defaultProps = {
        currency: currencies_1.DEFAULT_CURRENCY,
    };
    return CurrencySign;
}(react_1.default.Component));
exports.CurrencySign = CurrencySign;
//# sourceMappingURL=currency-sign.js.map